import { CheckOutlined } from '@ant-design/icons';
import { Button, DatePicker, Divider, Form, Modal, Popconfirm, Select, Table } from 'antd';
import { RangePickerProps } from 'antd/lib/date-picker';
import { ColumnsType } from 'antd/lib/table';
import { useEmployeeAddRequestMutation, useLazyPermitsQuery } from 'app/services/edpApiV1/vacationsSchedule';
import { useAppDispatch, useAppSelector } from 'app/store';
import { uiModel } from 'entities/ui';
import React, { SetStateAction, useEffect, useState } from 'react';
import {
  calculateAllDays,
  changeDataForTableDays,
  getErrorData,
  newDateOnDecemberYear,
  returnDays,
} from 'shared/helpers/utils';
import { useNotifications } from 'shared/hooks/use-notifications';
import { DataDaysScheduleType, DataScheduleType, TTypeSchedule } from 'shared/types/vacation-schedule.types';
import { Dayjs } from 'dayjs';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import { PICKER_DATE_MASK, SERVER_DATE_MASK } from 'shared/constants';
import moment from 'moment';
import style from './index.module.scss';

const { RangePicker } = DatePicker;

type TProps = {
  isModalAddOpen: boolean;
  setIsModalAddOpen: React.Dispatch<SetStateAction<boolean>>;
  employeeId: { employeeId: number; allAvailableOrganizations: boolean };
  fio: string;
  calendarTotalDays: number | null;
  firstRange: string | null;
};

const ModalAddSchedule = ({
  isModalAddOpen,
  setIsModalAddOpen,
  employeeId,
  fio,
  firstRange,
  calendarTotalDays,
}: TProps) => {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  // ошибка выбора даты периода отпуска
  const [periodError, setPeriodError] = useState<string>('');
  // массив видов всех отпусков
  const [allTypesVacations, setAllTypesVacations] = useState<TTypeSchedule[]>();
  // массив видов всех отпусков нужной формы
  const [typesVacationsForDays, setTypesVacationsForDays] = useState<DataDaysScheduleType[]>([]);
  // строка вида '0a5b37ca-79db-11ec-980f-005056b9ca73' устанавливает Вид отпуска
  const [vacationTypeId, setVacationTypeId] = useState<string>();
  // имя вида отпуска устанавливается в  Вид отпуска
  const [vacationTypeName, setVacationTypeName] = useState<string>();
  // счётчик дней отпуска доступные сотруднику
  const [vacationCounter, setVacationCounter] = useState<number>(0);
  //общее количество дней отпуска по всем видам
  const [allDaysCounter, setAllDaysCounter] = useState<number>(0);
  // выбор периода
  const [startedAt, setStartedAt] = useState<string>();
  const [endedAt, setEndedAt] = useState<string>();
  // данные которые попадают в таблицу
  const [dataSource, setDataSource] = useState<DataScheduleType[]>([]);
  // запрос на отпуска по id
  const [permitsTrigger, result] = useLazyPermitsQuery();
  // запрос на добавление
  const [addSceduleTrigger, resultAdd] = useEmployeeAddRequestMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  const { isSuccess: isSuccessAdd, isError: isErrorAdd, error: errorData, reset: resetAdd } = resultAdd;

  useNotifications(isSuccessAdd, isErrorAdd, 'Отпуска добавлены', errorData?.message, resetAdd);

  useNotifications(false, !!periodError, '', periodError, () => {
    setTimeout(() => setPeriodError(''), 1000);
  });

  const resetStates = () => {
    setDataSource([]);
    setVacationCounter(0);
    setVacationTypeId('');
    setVacationTypeName('');
    setStartedAt('');
    setEndedAt('');
    // устанавливаю счётчик суммы дней по всем отпускам в начальное состояние
    // заново мутирую массив видов отпусков
    if (allTypesVacations?.length) {
      setAllDaysCounter(calculateAllDays(allTypesVacations));
      setTypesVacationsForDays(changeDataForTableDays(allTypesVacations));
    }
    setPeriodError('');
    form.resetFields();
  };
  const handleAdd = () => {
    //  нужно при повторном добавлении отпуска например при ошибке
    resetAdd();

    if (vacationTypeName && startedAt && endedAt && vacationTypeId) {
      const newData = {
        key: (Math.random() + 1).toString(36).substring(7),
        id: vacationTypeId,
        vacationType: vacationTypeName,
        startedAt: startedAt,
        endedAt: endedAt,
        amountDays: returnDays(startedAt, endedAt),
      };

      // закидываю данные в таблицу
      setDataSource(prev => [...prev, newData]);
      //  механизм подсчёта отставшмхся дней
      if (typesVacationsForDays && typesVacationsForDays.length > 0 && newData) {
        setTypesVacationsForDays(prev => {
          if (prev) {
            const array = [...prev];

            return array?.map(elem => {
              if (elem.id === newData?.id) {
                if (elem?.resultDays && newData?.amountDays) {
                  const result = elem.resultDays - newData.amountDays;
                  elem.resultDays = result;
                  setVacationCounter(elem.resultDays);

                  let days = allDaysCounter;
                  days -= newData.amountDays;
                  setAllDaysCounter(days);
                  return elem;
                }
              }
              return elem;
            });
          }
          return prev;
        });
      }
    }

    form.resetFields();
    setStartedAt('');
    setEndedAt('');
    setVacationTypeId('');
  };

  const handleDelete = (key: React.Key, id: string | number | null | undefined) => {
    if (dataSource && id) {
      // отпуск может быть разбит на не сколько, тогда id не уникален использую key
      const type = dataSource.filter(el => el.id === id).find(el => el.key === key);

      let days = allDaysCounter;

      if (type?.amountDays) {
        days += type.amountDays;
        setAllDaysCounter(days);
      }

      if (typesVacationsForDays && typesVacationsForDays.length > 0 && type) {
        setTypesVacationsForDays(prev => {
          if (prev) {
            const array = [...prev];

            return array?.map(elem => {
              if (elem.id === type?.id) {
                if (elem?.resultDays !== null && elem?.resultDays !== undefined && type?.amountDays) {
                  const result = elem.resultDays + type.amountDays;
                  elem.resultDays = result;
                  setVacationCounter(elem.resultDays);
                  return elem;
                }
              }
              return elem;
            });
          }
          return prev;
        });
      }

      const newData = dataSource.filter(item => item.key !== key);
      setDataSource(newData);
    }
  };

  const columns: ColumnsType<DataScheduleType> = [
    {
      title: 'Вид отпуска',
      dataIndex: 'vacationType',
      key: 'vacationType',
    },
    {
      title: 'Дата начала',
      dataIndex: 'startedAt',
      key: 'startedAt',
    },
    {
      title: 'Дата окончания',
      dataIndex: 'endedAt',
      key: 'endedAt',
    },
    {
      title: 'Дни',
      dataIndex: 'amountDays',
      key: 'amountDays',
    },
    {
      title: 'Действие',
      dataIndex: 'action',
      key: 'action',
      render: (_, record: { key: React.Key; id?: string | number | null | undefined }) => {
        return (
          <Popconfirm
            placement="leftTop"
            title="Уверены?"
            onConfirm={() => {
              handleDelete(record.key, record?.id);
            }}
          >
            <a>Удалить</a>
          </Popconfirm>
        );
      },
    },
  ];

  const successAdd = () => {
    const dataForRequest = dataSource.map(el => {
      return {
        vacationTypeId: String(el.id),
        startedAt: moment(el.startedAt, PICKER_DATE_MASK).format(SERVER_DATE_MASK),
        endedAt: moment(el.endedAt, PICKER_DATE_MASK).format(SERVER_DATE_MASK),
      };
    });

    if (dataForRequest && dataForRequest.length > 0) {
      addSceduleTrigger({
        employeeId: employeeId.employeeId,
        requests: dataForRequest,
      });
    }

    if (isErrorAdd) {
      resetStates();
    }
  };

  const handleCancel = () => {
    setIsModalAddOpen(false);
    resetStates();
  };
  const onSelectType = (vacationTypeId: string) => {
    setVacationTypeId(vacationTypeId);
    const type = allTypesVacations?.find(el => el.vacationTypeId === vacationTypeId);

    setVacationTypeName(type?.name);
  };

  const onChangeDate = (value: RangePickerProps['value'], dateString: [string, string] | string) => {
    setPeriodError('');
    const chosenDaysCount = returnDays(dateString[0], dateString[1]);

    const vacationTypeData = typesVacationsForDays.find(v => v.id === vacationTypeId);

    if (vacationTypeData?.resultDays && vacationTypeData.resultDays < chosenDaysCount) {
      setPeriodError('Превышен лимит доступных дней');
      form.resetFields();
      setVacationCounter(0);
      setVacationTypeId('');
      return;
    }
    setStartedAt(dateString[0]);
    setEndedAt(dateString[1]);
  };

  const setRange = (_: [Dayjs | null, Dayjs | null] | null, val: [string, string]) => {
    dispatch(uiModel.VacationSchedule.actions.firstRange(val[0]));
  };

  const getTotalDays = (e: React.MouseEvent<HTMLDivElement>) => {
    if (firstRange) {
      const catchedDate = e?.currentTarget?.id;
      const totalCount = returnDays(firstRange, catchedDate);
      if (totalCount) {
        dispatch(uiModel.VacationSchedule.actions.calendarTotalDays(+totalCount));
      }
    }
  };
  // очищаю значение при каждом открытии календаря
  const clearTotalDays = () => {
    dispatch(uiModel.VacationSchedule.actions.calendarTotalDays(null));
    dispatch(uiModel.VacationSchedule.actions.firstRange(null));
  };
  // при открытии модалки
  // загружает по id виды отпуска доступные сотруднику
  useEffect(() => {
    if (employeeId) {
      permitsTrigger(employeeId);
    }
  }, [employeeId]);

  // при открытии модалки
  // устанавливает все виды отпуска
  useEffect(() => {
    if (result.data) {
      setAllTypesVacations(result.data);
    }
  }, [result.data]);

  // при открытии модалки
  // мутирует массив всех видов отпусков
  // устанавливает общее число дней отпуска по всем видам отпусков
  useEffect(() => {
    if (allTypesVacations && allTypesVacations?.length > 0) {
      // изменил структуру объекта
      setTypesVacationsForDays(changeDataForTableDays(allTypesVacations));
      // посчитал общее кол-во дней отпуска
      setAllDaysCounter(calculateAllDays(allTypesVacations));
    } else {
      // если нет доступных отпусков обнуляю счётчик общих дней по всем отпускам
      setAllDaysCounter(0);
    }
  }, [allTypesVacations]);

  // при открытии модалки
  // устанавливает количество дней отпуска
  useEffect(() => {
    if (typesVacationsForDays && typesVacationsForDays?.length > 0) {
      const type = typesVacationsForDays.find(el => el.id === vacationTypeId);
      if (type?.resultDays) {
        setVacationCounter(type.resultDays);
      } else {
        setVacationCounter(0);
      }
    } else {
      setVacationCounter(0);
    }

    if (typesVacationsForDays && typesVacationsForDays?.length > 0 && !vacationTypeId) {
      setVacationCounter(0);
    }
  }, [typesVacationsForDays, vacationTypeId]);

  useEffect(() => {
    if (isSuccessAdd) {
      setIsModalAddOpen(false);
      resetStates();
    }
  }, [isSuccessAdd]);

  return (
    <>
      <Modal
        title={`${
          vacationTypeId && vacationCounter ? `Доступно дней: ${vacationCounter}` : ''
        } Всего дней: ${allDaysCounter}`}
        visible={isModalAddOpen}
        onCancel={handleCancel}
        className={style.modalWrap}
        // убрал варнинг формы
        forceRender
        footer={[
          <div className={style.modalFooter} key="footer">
            <div className={style.modalInfo}>
              При применении изменений вы удалите все ранее заполненные сотрудником заявки на отпуск
            </div>
            <Button
              htmlType="submit"
              type="primary"
              icon={<CheckOutlined />}
              onClick={successAdd}
              disabled={allDaysCounter !== 0 || dataSource.length < 1}
            >
              Применить изменения
            </Button>
          </div>,
        ]}
      >
        <pre>{fio}</pre>
        <Form layout="vertical" form={form}>
          <Form.Item label="Вид отпуска" name="typeVacation">
            <Select placeholder="Выберите из списка" className={style.selectDivisions} onSelect={onSelectType}>
              {allTypesVacations?.map(({ vacationTypeId, name }) => (
                <Select.Option key={vacationTypeId} value={vacationTypeId}>
                  {name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Период" name="period">
            <RangePicker
              className={style.rangePeriod}
              format={PICKER_DATE_MASK}
              onChange={onChangeDate}
              disabled={!vacationTypeId}
              onOpenChange={clearTotalDays}
              renderExtraFooter={() =>
                firstRange ? <div>{`Общее количество дней: ${calendarTotalDays ? calendarTotalDays : 0}`}</div> : null
              }
              onCalendarChange={setRange}
              disabledDate={d =>
                !d ||
                d.isSame(
                  newDateOnDecemberYear(new Date(new Date().setFullYear(new Date().getFullYear())).getFullYear()),
                ) ||
                d.isBefore(
                  newDateOnDecemberYear(new Date(new Date().setFullYear(new Date().getFullYear())).getFullYear()),
                ) ||
                d.isAfter(
                  newDateOnDecemberYear(new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getFullYear()),
                )
              }
            />
          </Form.Item>
        </Form>

        <Button
          onClick={handleAdd}
          type="primary"
          style={{ marginBottom: 16 }}
          disabled={!vacationTypeId || !startedAt || !endedAt}
        >
          Добавить
        </Button>
        <Divider />

        <Table scroll={{ x: true }} columns={columns} dataSource={dataSource} />
      </Modal>
    </>
  );
};

export default ModalAddSchedule;
